import React, { useState } from 'react';

import UserApprovalsPage from "./UserApprovalsPage";
import { pending } from "./UserApprovalsPageSelector";
import UserApprovalsList from "./UserApprovalsList";
import { ISelectOption } from '../forms/util';

interface UserApprovalsDashboardProps {
    page: ISelectOption
}

const UserApprovalsDashboard = (props: UserApprovalsDashboardProps) => {
    const [selectedPage] = useState(props.page ?? pending);

    return (
        <UserApprovalsPage key={selectedPage.value} selectedPage={selectedPage}>
            <div className="ua-list-container">
                <UserApprovalsList title={selectedPage.label} />
            </div>
        </UserApprovalsPage>
    );
};

export default UserApprovalsDashboard;
